import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { Button, Modal, Progress, Row } from "antd";

import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as Strings from "../commons/string";
import * as TypeDTO from "../commons/typeDTO";
import * as Utils from "../utils/utils";

import PageContainer from "../layout/PageContainer";
import Smartkey from "../components/Smartkey";
import DriveInfo from "../components/DriveInfo";

import dash from "../assets/images/dash-image.svg";
import distanceIcon from "../assets/images/distanceIcon.svg";
import batteryIcon from "../assets/images/batteryIcon.svg";
import batteryIconTrans from "../assets/images/batteryIcon-trans.svg";
import driveAvgIcon from "../assets/images/driveAvgIcon.svg";
import bukgi from "../assets/images/car/bukgi-car.png";
import yaxing from "../assets/images/car/yaxing-car.png";
import yaxingDoorMode from "../assets/images/car/yaxing-car-door.png";
import yaxingSwingDoorMode from "../assets/images/car/yaxing-car-swingdoor.png";
import refreshIcon from "../assets/images/mypage/refreshIcon.svg";
import drawerBtn from "../assets/images/mypage/drawerBtn.svg";
import AddOnsDrawer from "../components/AddOnsDrawer";
import styles from "./Main.module.css";

const carVariants = {
    initial: {
        opacity: 0,
    },
    visible: {
        opacity: 1,
        transition: {
            duration: 0,
        }
    },
    hidden: {
        opacity: 0,
        transition: { delay: 1, },
    },
};

function Main() {
    const [myCars, setMyCars] = useState<Array<TypeDTO.CarOwnerDto>>();
    const [activeMyCars, setActiveMyCars] = useState<TypeDTO.CarOwnerDto>();
    const [openDrawer, setOpenDrawer] = useState(false);
    const [openModalSmartkeyActionError, setOpenModalSmartkeyActionError] = useState(false);
    const [smartkeyActionErrorMsg, setSmartkeyActionErrorMsg] = useState<string>();
    const [doorMode, setDoorMode] = useState<boolean>(false);
    const [swingDoorMode, setSwingDoorMode] = useState<boolean>(false);

    useEffect(() => {
        Utils.sendFCMToken();

        Utils.onEvent(Common.EVENT_CLOSE_ALL_DRAWER, handleCloseAllDrawer);
        Utils.onEvent(Common.EVENT_CLOSE_ALL_MODAL, handleCloseAllModal);

        return () => {
            Utils.offEvent(Common.EVENT_CLOSE_ALL_DRAWER, handleCloseAllDrawer);
            Utils.offEvent(Common.EVENT_CLOSE_ALL_MODAL, handleCloseAllModal);
        };
    }, []);

    const requestAxiosGetMyCars = async () => {
        const response = await utilAxiosWithAuth().get(Request.OWNERS_MINE_URL);
        return response.data;
    };

    const {
        loading: loadingGetMyCars,
        error: errorGetMyCars,
        data: resultGetMyCars,
        execute: requestGetMyCars,
    } = useAsyncAxios(requestAxiosGetMyCars);

    useEffect(() => {
        if (!resultGetMyCars) return;
        console.log("resultGetMyCars", resultGetMyCars);

        setMyCars(resultGetMyCars.carOwners);
    }, [resultGetMyCars]);

    useEffect(() => {
        if (!errorGetMyCars) return;

        console.log("errorGetMyCars", errorGetMyCars);
    }, [errorGetMyCars]);

    useEffect(() => {
        if (!myCars || myCars.length === 0) {
            setActiveMyCars(undefined);
        } else {
            const activeCars = myCars.filter((car) => car.active === true);
            if (activeCars && activeCars.length > 0) {
                setActiveMyCars(activeCars[0]);
            } else setActiveMyCars(undefined);
        }
    }, [myCars]);

    useEffect(() => {
        if (activeMyCars && activeMyCars.car && activeMyCars.car.batterySoc && activeMyCars.car.subBatteryStatus) {
            Utils.triggerEvent(Common.EVENT_BATTERY, { battery: activeMyCars.car.batterySoc, subBattery: activeMyCars.car.subBatteryStatus });
        }
    }, [activeMyCars]);

    useEffect(() => {
        requestGetMyCars();
    }, []);

    useEffect(() => {
        if (openModalSmartkeyActionError === true) Utils.addModalStack();
        else Utils.popModalStack();
    }, [openModalSmartkeyActionError]);

    const handleCloseAllModal = () => {
        setOpenModalSmartkeyActionError(false);
    };

    const onSmartkeyActionError = (message: string) => {
        setOpenModalSmartkeyActionError(true);
        setSmartkeyActionErrorMsg(message);
    };

    const onHandleDoor = (isActive: boolean, doorType: Common.DoorType) => {
        switch (doorType) {
            case Common.DoorType.DOOR:
                setDoorMode(isActive);
                break;
            case Common.DoorType.SWING_DOOR:
                setSwingDoorMode(isActive);
                break;
        }
    };

    const updateVehicleInfo = () => {
        requestGetMyCars();
    };

    const handleDrawerBtnClick = () => {
        setOpenDrawer(true);
    };

    const handleCloseAllDrawer = () => {
        setOpenDrawer(false);
    };
    return (
        <PageContainer contentPadding={16}>
            <Row align="middle" justify="center">
                <div className="container">
                    <div className={styles.topContainer}>
                        <div className={styles.topSection}>
                            <div className={styles.pageTitle}>
                                <h1 className={styles.titleText}>{activeMyCars ? activeMyCars.car.carNumber : "차량을 등록해 주세요."}</h1>
                                <img width={56} height={10} src={dash} alt="dash design in yellow" className={styles.dash} />
                            </div>
                            <div className={styles.refreshIconContainer}>
                                <motion.img
                                    initial={{ rotate: 360 }}
                                    animate={loadingGetMyCars ? { rotate: [0, 360] } : "stop"}
                                    transition={{
                                        type: "spring",
                                        damping: 20,
                                    }}
                                    src={refreshIcon}
                                    width="22"
                                    height="22"
                                    onClick={updateVehicleInfo}
                                />
                            </div>
                        </div>
                        <div className={`${styles.spotlight}`} style={{ opacity: activeMyCars ? 1 : 0.4 }}>
                            <div
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                {activeMyCars?.car.hasSwingDoor !== undefined &&
                                    (!activeMyCars.car.hasSwingDoor ? (
                                        <img src={bukgi} className={styles.bukgiCar} />
                                    ) : (
                                        <>
                                            <img src={yaxing} className={styles.yaxingCar} />
                                            <motion.img
                                                variants={carVariants}
                                                initial="initial"
                                                animate={doorMode ? "visible" : "hidden"}
                                                src={yaxingDoorMode}
                                                className={styles.yaxingCar}
                                            />
                                            <motion.img
                                                variants={carVariants}
                                                initial="initial"
                                                animate={swingDoorMode ? "visible" : "hidden"}
                                                src={yaxingSwingDoorMode}
                                                className={styles.yaxingCar}
                                            />
                                        </>
                                    ))}
                            </div>

                            <div className={styles.dataContainer}>
                                <Progress
                                    className={styles.batteryProgress}
                                    size={[-1, 6]}
                                    strokeLinecap="butt"
                                    strokeColor="black"
                                    trailColor="white"
                                    percent={Math.round((activeMyCars?.car.batterySoc || 0) * 10) / 10}
                                    showInfo={false}
                                />
                                <div className={styles.batteryWrapper}>
                                    <div style={{ display: "flex", gap: 4 }}>
                                        <img className={styles.icon} src={batteryIconTrans} />
                                        <p className={styles.title}>SOC</p>
                                    </div>
                                    <div className={styles.dataBody}>
                                        {activeMyCars ? (
                                            <span
                                                className={`${styles.itemData} ${
                                                    (activeMyCars.car.batterySoc <= 40 && activeMyCars.car.batterySoc > 30 && styles.littleLowBattery) ||
                                                    (activeMyCars.car.batterySoc <= 30 && activeMyCars.car.batterySoc > 20 && styles.lowBattery) ||
                                                    (activeMyCars.car.batterySoc <= 20 && activeMyCars.car.batterySoc > 0 && styles.veryLowBattery)
                                                }`}
                                            >
                                                {String(Math.round(activeMyCars.car.batterySoc * 10) / 10)} <span style={{ fontSize: 14 }}>%</span>
                                            </span>
                                        ) : (
                                            <span className={`${styles.itemData}`}>{Strings.dash}</span>
                                        )}
                                    </div>
                                </div>

                                {/* <div className={styles.item}>
                                    <span className={styles.itemTitle}>보조배터리 전압</span>
                                    {activeMyCars ? (
                                        <span
                                            className={`${styles.itemData} ${
                                                (activeMyCars.car.subBatteryStatus === "LOW" && styles.lowBattery) ||
                                                (activeMyCars.car.subBatteryStatus === "VERY_LOW" && styles.veryLowBattery)
                                            }`}
                                        >
                                            {activeMyCars.car.subBatteryStatus !== null
                                                ? Utils.convertSubBatteryStatus(activeMyCars.car.subBatteryStatus)
                                                : "-"}
                                        </span>
                                    ) : (
                                        <span className={`${styles.itemData}`}>{Strings.dash}</span>
                                    )}
                                </div> */}
                            </div>
                        </div>
                    </div>

                    <Smartkey activeCar={activeMyCars} onSmartkeyActionError={onSmartkeyActionError} onHandleDoor={onHandleDoor} />

                    <div style={{ marginBottom: 28 }}>
                        <p className={styles.infotext}>최근 주행 정보</p>
                        <div className={styles.driveInfo}>
                            <DriveInfo
                                icon={distanceIcon}
                                title="운행 거리"
                                data={
                                    activeMyCars?.car.recentDrivingDistance
                                        ? String(Math.round(activeMyCars.car.recentDrivingDistance * 10) / 10)
                                        : "- -"
                                }
                                unit="km"
                            />
                            <DriveInfo
                                icon={batteryIcon}
                                title="배터리 사용량"
                                data={
                                    activeMyCars?.car.recentBatteryUsage ? String(Math.round(activeMyCars.car.recentBatteryUsage * 10) / 10) : "- -"
                                }
                                unit="kWh"
                            />
                            <DriveInfo
                                icon={driveAvgIcon}
                                title="평균 주행 전비"
                                data={
                                    activeMyCars?.car.recentElectricMileage
                                        ? String(Math.round(activeMyCars.car.recentElectricMileage * 10) / 10)
                                        : "- -"
                                }
                                unit="km/kWh"
                            />
                        </div>
                    </div>

                    <motion.div className={styles.drawerBtnContainer} onClick={handleDrawerBtnClick} whileTap={{ y: 4 }}>
                        <img className={styles.drawerBtn} alt="icon for opening bottom drawer" src={drawerBtn} height={26} width={32} />
                    </motion.div>
                    <AddOnsDrawer openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} />
                    <Modal
                        className="confirmModal"
                        centered
                        key="modalSmartkeyActionError"
                        open={openModalSmartkeyActionError}
                        closable={false}
                        onCancel={() => setOpenModalSmartkeyActionError(false)}
                        footer={[
                            <Button block type="primary" key="back" onClick={() => setOpenModalSmartkeyActionError(false)}>
                                {Strings.confirm}
                            </Button>,
                        ]}
                    >
                        <Row justify={"center"} align={"middle"}>
                            {smartkeyActionErrorMsg}
                        </Row>
                    </Modal>
                </div>
            </Row>
        </PageContainer>
    );
}

export default Main;
